import { createI18n } from 'vue-i18n'

import localizationEn from './assets/localization.en.json';
import localizationCs from './assets/localization.cs.json';
import localizationFi from './assets/localization.fi.json';

const savedLocale = localStorage.getItem('locale') || 'en'

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  availableLocales: ['en', 'cs', 'fi'],
  messages: {
    en: localizationEn,
    cs: localizationCs,
    fi: localizationFi
  }
})